import { HTMLAttributes } from 'react'
import { styled } from '@mui/material'
import { DRAWER_WIDTH } from './Drawer'
import { isGlobalworth } from 'config'

export const Container = styled('div')({
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
})

export interface ContentProps extends Partial<HTMLAttributes<HTMLDivElement>> {
  shrink?: boolean
  lockViewportHeight?: boolean
}

export const Content = styled('main', {
  shouldForwardProp: prop => prop !== 'shrink' && prop !== 'lockViewportHeight',
})<ContentProps>(({ shrink, lockViewportHeight, theme }) => ({
  flexGrow: 1,
  height: 'calc(100vh - 65px)',
  display: 'flex',
  paddingLeft: shrink ? DRAWER_WIDTH + 20 : 0,
  overflowX: 'hidden',
  backgroundImage: 'none',
  backgroundColor: isGlobalworth ? 'none' : '#f0f0f0',
  overflowY: 'auto',

  ...(lockViewportHeight && {
    maxHeight: 'calc(100vh - 65px)',
    minHeight: 0,

    '@supports (height: 100dvh)': {
      height: 'calc(100dvh - 65px)',
      maxHeight: 'calc(100dvh - 65px)',
    },

    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 56px)',
      maxHeight: 'calc(100vh - 56px)',

      '@supports (height: 100dvh)': {
        height: 'calc(100dvh - 56px)',
        maxHeight: 'calc(100dvh - 56px)',
      },
    },
  }),
}))
